<!-- rendering from templates -->
<div *ngIf="html" class="panel-content" [innerHtml]="html | sanitizeHtml"></div>
<!-- rendering from templates end -->

<mat-accordion>
  <!-- Distance Accordion -->
  <mat-expansion-panel
    #panel
    class="panel2"
    (opened)="panelOpenState = true; expanded('LineString', 1)"
    (closed)="panelOpenState = false"
    hideToggle="true"
    [expanded]="state.expandPanel1"
  >
    <mat-expansion-panel-header (click)="getDistance('LineString', 1)">
      <mat-panel-title
        class="distance"
        title="{{ metricsData['metrics-distance'] }}"
      >
        Distance
      </mat-panel-title>
      <mat-panel-description>
        <input
          class="radio"
          type="radio"
          name="metircs"
          value="0"
          [checked]="panelOpenState"
        />
        <mat-icon class="arrow_icon" *ngIf="panelOpenState"
          >arrow_drop_down</mat-icon
        >
        <mat-icon class="arrow_icon" *ngIf="!panelOpenState"
          >arrow_drop_up</mat-icon
        >
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="distance-section">
      <table class="distance-table">
        <tbody>
          <tr class="tr-distance">
            <td
              class="metrics-position-lat"
              *ngIf="feet"
              [ngClass]="feet ? 'width3' : 'width4'"
            >
              {{ feet | number }}
            </td>
            <td class="td-distance" title="feet">ft</td>
          </tr>
          <tr class="tr-distance">
            <td
              class="metrics-position-lon"
              *ngIf="feetToMiles"
              [ngClass]="feetToMiles ? 'width3' : 'width4'"
            >
              {{ feetToMiles | number }}
            </td>
            <td title="miles" class="td-distance">mi</td>
            <!-- <td matTooltipShowDelay="1000" matTooltip="miles"></td> -->
          </tr>
          <tr>
            <td
              class="metrics-position-lon"
              *ngIf="feetToMeter"
              [ngClass]="feetToMeter ? 'width3' : 'width4'"
            >
              {{ feetToMeter | number }}
            </td>
            <td title="meters" class="td-distance">m</td>
            <!-- <td matTooltipShowDelay="1000" matTooltip="meters"></td> -->
          </tr>
          <tr>
            <td
              class="metrics-position-lon"
              *ngIf="feetToKilometer"
              [ngClass]="feetToKilometer ? 'width3' : 'width4'"
            >
              {{ feetToKilometer | number }}
            </td>
            <td title="kilometers" class="td-distance">km</td>
            <!-- <td matTooltipShowDelay="1000" matTooltip="kilometers"></td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
  <!-- Area Accordion -->
  <mat-expansion-panel
    #panel1
    class="area_expansion"
    class="panel3"
    (opened)="panelOpenState1 = true; expanded('Polygon', 2)"
    (closed)="panelOpenState1 = false"
    hideToggle="true"
    [expanded]="state.expandPanel2"
  >
    <mat-expansion-panel-header (click)="getDistance('Polygon', 2)">
      <mat-panel-title class="area" title="{{ metricsData['metrics-area'] }}">
        Area
      </mat-panel-title>
      <mat-panel-description>
        <input
          class="radio"
          type="radio"
          name="metircs"
          value="0"
          [checked]="panelOpenState1"
        />
        <mat-icon class="arrow_icon" *ngIf="panelOpenState1"
          >arrow_drop_down</mat-icon
        >
        <mat-icon class="arrow_icon" *ngIf="!panelOpenState1"
          >arrow_drop_up</mat-icon
        >
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="area-section">
      <table class="areaTable area-table">
        <tbody>
          <tr>
            <td id="metrics-area-ft2" class="td-area" *ngIf="feet">
              {{ feet | number }}
            </td>
            <td
              title="square feet"
              class="align"
              [ngClass]="!feet ? 'area1' : 'area2'"
            >
              ft<sup>2</sup>
            </td>
          </tr>
          <tr>
            <td id="metrics-area-ac" class="td-area" *ngIf="meterSqaureToAcres">
              {{ meterSqaureToAcres | number }}
            </td>
            <td
              title="acres"
              class="align"
              [ngClass]="!meterSqaureToAcres ? 'area1' : 'area2'"
            >
              ac
            </td>
          </tr>
          <tr>
            <td id="metrics-area-mi2" class="td-area" *ngIf="feetToMiles">
              {{ feetToMiles | number }}
            </td>
            <td
              title="square miles"
              class="align"
              [ngClass]="!feetToMiles ? 'area1' : 'area2'"
            >
              mi<sup>2</sup>
            </td>
          </tr>
          <tr>
            <td id="metrics-area-m2" class="td-area" *ngIf="feetToMeter">
              {{ feetToMeter | number }}
            </td>
            <td
              title="square meters"
              class="align"
              [ngClass]="!feetToMeter ? 'area1' : 'area2'"
            >
              m<sup>2</sup>
            </td>
          </tr>
          <tr>
            <td
              id="metrics-area-ha"
              class="td-area"
              *ngIf="meterSqaureToMilesSqaure"
            >
              {{ meterSqaureToMilesSqaure | number }}
            </td>
            <td
              title="hectares"
              class="align"
              [ngClass]="!meterSqaureToMilesSqaure ? 'area1' : 'area2'"
            >
              ha
            </td>
          </tr>
          <tr>
            <td id="metrics-area-km2" class="td-area" *ngIf="feetToKilometer">
              {{ feetToKilometer | number }}
            </td>
            <td
              title="square kilometers"
              class="align"
              [ngClass]="!feetToMeter ? 'area1' : 'area2'"
            >
              km<sup>2</sup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
  <!-- Position Accordion -->
   <!-- Position Accordion -->
   <mat-expansion-panel
   #panel2
   class="position_expansion"
   (opened)="panelOpenState2 = true; expanded('Point', 3)"
   class="panel1"
   (closed)="panelOpenState2 = false"
   hideToggle="true"
   [expanded]="state.expandPanel3"
 >
   <mat-expansion-panel-header (click)="getDistance('Point', 3)">
     <mat-panel-title
       class="position"
       title="{{ metricsData['metrics-position'] }}"
     >
       Position
     </mat-panel-title>
     <mat-panel-description>
       <input
         class="radio"
         type="radio"
         name="metircs"
         value="0"
         [checked]="panelOpenState2"
       />
       <mat-icon class="arrow_icon" *ngIf="panelOpenState2"
         >arrow_drop_down</mat-icon
       >
       <mat-icon class="arrow_icon" *ngIf="!panelOpenState2"
         >arrow_drop_up</mat-icon
       >
     </mat-panel-description>
   </mat-expansion-panel-header>
   <div class="position-section">
     <table>
       <tbody>
         <span>Decimal Degrees</span>
         <tr class="tr-latlon">
           <td class="common-head" [ngClass]="lati ? 'width1' : 'width2'">
             Latitude
           </td>
           <td
             class="metrics-position-lat"
             *ngIf="lati"
             (click)="copyToClipboard(lati)"
           >
             {{ lati }}
           </td>
           <td class="value-class" title="degrees">deg</td>
         </tr>
         <tr class="tr-latlon" style="margin-bottom: 10px">
           <td class="common-head" [ngClass]="lon ? 'width1' : 'width2'">
             Longitude
           </td>
           <td
             class="metrics-position-lon"
             *ngIf="lon"
             (click)="copyToClipboard(lon)"
           >
             {{ lon }}
           </td>
           <td class="value-class" title="degrees">deg</td>
         </tr>
         <!-- point into minutes seconds degrees -->
         <span>Degrees, Minutes, Seconds</span>
         <tr class="tr-latlon">
           <td class="common-head" [ngClass]="lati ? 'width1' : 'width2'">
             Latitude
           </td>
           <td
             class="metrics-position-lat"
             *ngIf="lati"
             (click)="copyToClipboard(latDMSV)"
           >
             {{ latDMSV }}
           </td>
         </tr>
         <tr class="tr-latlon" style="margin-bottom: 10px">
           <td class="common-head" [ngClass]="lon ? 'width1' : 'width2'">
             Longitude
           </td>
           <td
             class="metrics-position-lon"
             *ngIf="lon"
             (click)="copyToClipboard(lonDMSV)"
           >
             {{ lonDMSV }}
           </td>
         </tr>
         <!-- point into minutes seconds degrees -->
         <span>UTM</span>
         <tr class="tr-latlon">
           <td class="common-head" [ngClass]="lati ? 'width1' : 'width2'">
             Easting
           </td>
           <td
             class="metrics-position-lat"
             *ngIf="lati"
             (click)="copyToClipboard(utmEasting)"
           >
             {{ utmEasting }}
           </td>
         </tr>
         <tr class="tr-latlon">
           <td class="common-head" [ngClass]="lon ? 'width1' : 'width2'">
             Northing
           </td>
           <td
             class="metrics-position-lon"
             *ngIf="lon"
             (click)="copyToClipboard(utmNorthing)"
           >
             {{ utmNorthing }}
           </td>
         </tr>
         <tr class="tr-latlon">
           <td class="common-head" [ngClass]="lon ? 'width1' : 'width2'">
             Zone
           </td>
           <td
             class="metrics-position-lon"
             *ngIf="lon"
             (click)="copyToClipboard(utmZone)"
           >
             {{ utmZone }}
           </td>
         </tr>
       </tbody>
     </table>
   </div>
 </mat-expansion-panel>
</mat-accordion>
<div class="buttonDiv">
  <a class="closer closerToolTip">
    <img
      (click)="reset()"
      (click)="closeLeftPanel()"
      class="closer-img common-btns tool-toolTip"
      src="/assets/img/tools/close-pv3.png"
      alt="closer" /><span
      class="tooltiptext tip-bottom"
      [innerHtml]="mapService.templatetoolTips['close_left_panel']"
    ></span
  ></a>
  <a class="closer closerToolTip">
    <img
      (click)="reset()"
      class="arrow-img common-btns tool-toolTip"
      src="/assets/img/tools/two-circling-arrows.png"
      alt="closer"
    /><span class="tooltiptextclear tooltiptext tip-bottom"
      >Clear selection</span
    ></a
  >
</div>
